/* eslint-disable no-console */
import React from 'react';
import ReactDOM from 'react-dom';

import SearchBox from '../../search-box/jsx/SearchBox';
import SearchBanner from '../../hero-search-banner/jsx/HeroSearchBanner';
import SearchFacets from './components/SearchFacets';
import SearchResults from './components/SearchResults';
import SearchSummary from './components/SearchSummary';
import FunnelbackProvider from './data/FunnelbackProvider';
// import SearchBox from './components/SearchBox';
import Comparisons from './components/Comparisons';
import Favourites from './components/Favourites';
import Pagination from './components/Pagination';

const whitelistedComponents = [
    { 'funnelback-instant-search-box': SearchBox },
    { 'funnelback-instant-search-banner': SearchBanner },
    { 'funnelback-instant-search-facets': SearchFacets },
    { 'funnelback-instant-search-summary': SearchSummary },
    { 'funnelback-instant-search-results': SearchResults },
    { 'funnelback-instant-search-pagination': Pagination },
    { 'funnelback-instant-search-favourites': Favourites },
    { 'funnelback-instant-search-comparisons': Comparisons },
];

/**
 * Creates portals, whenever HTML roots are provided.
 *
 * @param {object} children Components
 * @param {HTML Element} parent Root of the HTML element.
 *
 * @returns {React.ReactPortal}
 * @constructor
 */
const Portal = ({ children, parent }) => {
    const [container] = React.useState(() => {
        return document.createElement('div');
    });

    React.useEffect(() => {
        parent.appendChild(container);
        return () => {
            parent.removeChild(container);
        };
    }, []);

    return ReactDOM.createPortal(children, container);
};

/**
 * Wraps all whitelisted component into on search provider.
 * @param {object} props Object with initial properties passed down to provider and components.
 *
 * @returns {JSX.Element}
 * @constructor
 */
function FunnelbackInstantSearch(props) {
    const components = [];
    const searchPartials = document.querySelectorAll(`[data-component*="funnelback-instant-search-"]`);

    searchPartials.forEach((parent) => {
        const componentName = parent.dataset.component;

        const component = whitelistedComponents.filter((e) => e[componentName])?.[0]?.[componentName];

        if (!component) {
            console.warn(`Component with name ${componentName} is not registered`);
            return;
        }

        let configuration = {};
        if (parent.dataset.configuration) {
            try {
                configuration = JSON.parse(parent.dataset.configuration);
            } catch (e) {
                console.warn(`Error while tyring to parse configuration for component: ${componentName}`);
            }
        }

        // eslint-disable-next-line react/destructuring-assignment
        const componentLayerConfig = props[componentName];
        if (componentLayerConfig) {
            configuration = { ...configuration, ...componentLayerConfig };
        }

        components.push({
            id: parent.id,
            component,
            parent,
            configuration,
        });
    });

    return (
        <FunnelbackProvider {...props}>
            {components.map((el) => {
                return (
                    <Portal parent={el.parent} key={`portal-id-${el.id}`}>
                        {React.createElement(el.component, el.configuration)}
                    </Portal>
                );
            })}
        </FunnelbackProvider>
    );
}

export default FunnelbackInstantSearch;
